import { SIGNAL_R_EVENT_RECEIVED, WAIT_FOR_EVENT_SUBSCRIBE } from "../actions/actionTypes";
import initialState from "./initialState";

const updateOrCreateEventList = (state, correlationId, item) => {
  let newListOfEvents = [];

  if (state[correlationId]) {
    newListOfEvents = [...state[correlationId]];
  }

  newListOfEvents.push(item);
  return { ...state, [correlationId]: [...newListOfEvents] };
};

const createIfNotExistEventList = (state, correlationId) => {
  return { [correlationId]: [], ...state };
};

export default function asyncCommandReducer(state = initialState.serverEvents, action) {
  switch (action.type) {
    case WAIT_FOR_EVENT_SUBSCRIBE:
      return createIfNotExistEventList(state, action.payload.correlationId);
    case SIGNAL_R_EVENT_RECEIVED:
      return updateOrCreateEventList(state, action.event.correlationId, action.event);
    default:
      return state;
  }
}
